/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* ===== WiFi Center — interactief mega-menu (rail wisselt kolommen) ===== */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.wc-mega').forEach(function (mega) {
    var items = mega.querySelectorAll('.wc-mega__rail-item');
    var panels = mega.querySelectorAll('.wc-mega__panel');
    if (!items.length || !panels.length) return;
    function activate(idx) {
      items.forEach(function (it) { it.classList.toggle('is-active', it.getAttribute('data-wc-target') === String(idx)); });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-wc-panel') === String(idx)); });
    }
    items.forEach(function (it) {
      var idx = it.getAttribute('data-wc-target');
      it.addEventListener('mouseenter', function () { activate(idx); });
      it.addEventListener('focus', function () { activate(idx); });
    });
  });
});
/* WiFi Center — accurate "vandaag verzonden"-indicatie.
   De server rendert een neutrale of optimistische tekst; dit corrigeert dat naar de
   werkelijke eerstvolgende verzenddag o.b.v. NL-tijd (verzending ma-vr).
   Cutoff per element via data-cutoff="23" (uur, standaard 23 = 23:00). Houd gelijk aan
   de levertijd-tekst op de productpagina (templates/product.json).
   Voorkomt een misleidende verzendbelofte na de cutoff of in het weekend. */
(function () {
  var nodes = document.querySelectorAll('[data-ship-today]');
  if (!nodes.length && !document.getElementById('mini-cart')) return;
  var DEFAULT_CUTOFF = 23; // uur
  var nl;
  try { nl = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' })); }
  catch (e) { return; } // laat de server-tekst staan als tijdzone-conversie faalt
  var day = nl.getDay();   // 0 = zondag ... 6 = zaterdag
  var hour = nl.getHours();
  var weekday = day >= 1 && day <= 5;
  var T = window.wcStrings || {};
  function labelFor(cutoff) {
    if (weekday && hour < cutoff) return T.shipToday || 'vandaag verzonden';
    if ((day === 5 && hour >= cutoff) || day === 6 || day === 0) return T.shipMonday || 'maandag verzonden';
    return T.shipTomorrow || 'morgen verzonden';
  }
  // In de productkaart (.wc-stock) staat "vandaag verzonden" op een eigen regel,
  // uitgelijnd onder "Op voorraad" - daar geen scheidingsteken. In de inline-
  // contexten (pdp, categorie, cart, zoeken) wel ' · ' als scheiding.
  // data-ship-full (cart-drawer): vóór de cutoff blijft de server-tekst ("Voor 16.00 besteld,
  // dezelfde dag verzonden") staan; daarna "Morgen verzonden" / "Maandag verzonden".
  function apply(n) {
    if (n.hasAttribute('data-ship-done')) return;
    n.setAttribute('data-ship-done', '');
    var cutoff = parseInt(n.getAttribute('data-cutoff'), 10);
    if (isNaN(cutoff) || cutoff < 0 || cutoff > 24) cutoff = DEFAULT_CUTOFF;
    var label = labelFor(cutoff);
    var inCard = n.closest && n.closest('.wc-stock');
    if (n.hasAttribute('data-ship-full')) {
      if (label !== (T.shipToday || 'vandaag verzonden')) n.textContent = label.charAt(0).toUpperCase() + label.slice(1);
    } else if (n.hasAttribute('data-ship-bare')) {
      n.textContent = label.charAt(0).toUpperCase() + label.slice(1);
    } else {
      n.textContent = inCard ? label : (' · ' + label);
    }
  }
  nodes.forEach(apply);
  // De cart-drawer wordt na elke wijziging opnieuw gerenderd; corrigeer nieuwe nodes ook.
  var drawer = document.getElementById('mini-cart');
  if (drawer && window.MutationObserver) {
    new MutationObserver(function () {
      drawer.querySelectorAll('[data-ship-today]:not([data-ship-done])').forEach(apply);
    }).observe(drawer, { childList: true, subtree: true });
  }
})();

/* WiFi Center — live catalogusteller voor [product_count] (snippets/wc-tokens).
   De server rendert het aantal producten; hier tellen we alle varianten op via de sectie
   wc-catalog-count (250 producten per pagina) en cachen het totaal 24 uur. */
(function () {
  var nodes = document.querySelectorAll('[data-wc-catalog-count]');
  if (!nodes.length || !window.fetch) return;
  var KEY = 'wcCatalogCount', DAY = 864e5;

  function fmt(n) {
    var step = n >= 10000 ? 1000 : (n >= 100 ? 100 : 10);
    var r = Math.floor(n / step) * step;
    return r.toLocaleString('nl-NL');
  }
  function apply(n) {
    if (!(n > 0)) return;
    nodes.forEach(function (el) { el.textContent = fmt(n); });
  }
  try {
    var cached = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (cached && Date.now() - cached.t < DAY) { apply(cached.n); return; }
  } catch (e) {}

  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function page(p) {
    return fetch(base + 'collections/all?section_id=wc-catalog-count&page=' + p, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var m = html.match(/data-wc-variants="(\d+)"\s+data-wc-pages="(\d+)"/);
        if (!m) throw new Error('no count');
        return { v: +m[1], pages: +m[2] };
      });
  }
  page(1).then(function (first) {
    var rest = [];
    for (var p = 2; p <= Math.min(first.pages, 40); p++) rest.push(page(p));
    return Promise.all(rest).then(function (others) {
      return others.reduce(function (sum, o) { return sum + o.v; }, first.v);
    });
  }).then(function (total) {
    apply(total);
    try { localStorage.setItem(KEY, JSON.stringify({ n: total, t: Date.now() })); } catch (e) {}
  }).catch(function () { /* server-waarde (aantal producten) blijft staan */ });
})();

/* Winkelwagen-upsell (mini-cart + cart-recommendations): haalt sections/wc-cart-upsell op via de zoek-URL
   in data-url (producten met marge-tag ≥ minimum), pakt de opmaak uit [data-layout] en toont max. data-limit.
   Gecachet per wagen-inhoud (data-key), zodat het her-renderen van de drawer niet opnieuw ophaalt. */
(function () {
  if (window.customElements.get('wc-cart-upsell')) return;
  var cache = {};

  window.customElements.define('wc-cart-upsell', class extends HTMLElement {
    connectedCallback() {
      var url = this.dataset.url, key = url + '|' + (this.dataset.key || '');
      if (!url) return;
      if (!cache[key]) {
        cache[key] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        });
      }
      cache[key].then(this._render.bind(this)).catch(function () { delete cache[key]; });
    }

    _render(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var source = doc.querySelector('[data-layout="' + this.dataset.layout + '"]');
      var list = this.querySelector('[data-upsell-list]');
      if (!source || !list) return;
      var items = Array.from(source.children).slice(0, parseInt(this.dataset.limit, 10) || 4);
      if (!items.length) { this.hidden = true; return; }
      list.replaceChildren.apply(list, items.map(function (el) { return document.importNode(el, true); }));
      this.hidden = false;
    }
  });
})();
